// Copyright (c) 2016 Deere & Company

import './popover.scss';
import React, {PropTypes} from 'react';
import Overlay from 'react-overlays/lib/Overlay';
import ToolTip from './tooltip';

function hide() {

    return this.setState({show: false});

}

function toggle(e) {

    if (e.message === 'block') {

        e.message = null;

    } else {

        this.setState({show: !this.state.show});

    }

}

function getOverlayTargetClass() {

    let targetClass;

    targetClass = this.state.show ? 'overlay-target active' : 'overlay-target';
    if (this.props.additionalClass) {

        targetClass += ` ${this.props.additionalClass}`;

    }

    return targetClass;

}

class Popover extends React.Component {

    constructor(props) {

        super(props);
        this.state = {show: false};

    }

    render() {

        return (
            <div
                className={this::getOverlayTargetClass()}
                onClick={this::toggle}
            >
                <div onClick={this::toggle}>
                    {this.props.target}
                </div>
                <Overlay
                    container={this}
                    onHide={this::hide}
                    placement='bottom'
                    rootClose={true}
                    show={this.state.show}
                >
                    <ToolTip>
                        {this.props.content}
                    </ToolTip>
                </Overlay>
            </div>
        );

    }

}

Popover.displayName = 'Popover';
Popover.propTypes = {
    additionalClass: PropTypes.string,
    content: PropTypes.node,
    target: PropTypes.node
};

export default Popover;



// WEBPACK FOOTER //
// ./src/shared/components/popover/popover.js